import { module } from 'angular';
import App from '../../../app';

class SCR0709Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		if(!data.width) data.width = 1065;
		if(!data.height) data.height = 800;
		
		this.initWindow(data.width, data.height);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.initBizCdGridOption();
			this.getCrsNo();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMciInterface'));
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initBizCdGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
			{
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
			{fieldName: "INST_ID"}, {fieldName: "DOC_NO"}, {fieldName: "INST_NAME"}, {fieldName: "ACT_NAME"}, 
			{fieldName: "PROC_NAME"}, {fieldName: "INST_START_NM"}, {fieldName: "INST_START_DT"}, {fieldName: "WORK_START_DT"},
			{
            	fieldName: "INST_START_DT_TXT",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		const instStartDt = values[fieldNames.indexOf('INST_START_DT')];
  
					const yy = instStartDt.substring(0,4);
					const mm = instStartDt.substring(4,6);
					const dd = instStartDt.substring(6,8);
					const hh = instStartDt.substring(8,10);
					const mi = instStartDt.substring(10,12);
					const ss = instStartDt.substring(12,14);
					
					return yy+"/"+mm+"/"+dd+" "+hh+":"+mi+":"+ss;
        		}
    		},
    		{
            	fieldName: "WORK_START_DT_TXT",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		const workStartDt = values[fieldNames.indexOf('WORK_START_DT')];
            		
            		const yy = workStartDt.substring(0,4);
					const mm = workStartDt.substring(4,6);
					const dd = workStartDt.substring(6,8);
					const hh = workStartDt.substring(8,10);
					const mi = workStartDt.substring(10,12);
					const ss = workStartDt.substring(12,14);
					
					return yy+"/"+mm+"/"+dd+" "+hh+":"+mi+":"+ss;
        		}
    		}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "No" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "INST_ID", fieldName: "INST_ID", header : { text: this.text.instId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "DOC_NO", fieldName: "DOC_NO", header : { text: this.text.docNo }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "INST_NAME", fieldName: "INST_NAME", header : { text: this.text.instName }, width: 270, styles: { textAlignment: 'center' } },
			{ name: "ACT_NAME", fieldName: "ACT_NAME", header : { text: this.text.actName }, width: 70, styles: { textAlignment: 'center' } },
			{ name: "PROC_NAME", fieldName: "PROC_NAME", header : { text: this.text.procName }, width: 70, styles: { textAlignment: 'center' } },
			{ name: "INST_START_NM", fieldName: "INST_START_NM", header : { text: this.text.instStartNm }, width: 80, styles: { textAlignment: 'center' } },
			{ name: "INST_START_DT", fieldName: "INST_START_DT_TXT", header : { text: this.text.instStartDt }, width: 130, styles: { textAlignment: 'center' } },
			{ name: "WORK_START_DT", fieldName: "WORK_START_DT_TXT", header : { text: this.text.workStartDt }, width: 130, styles: { textAlignment: 'center' } },
			{ 
				name: "buttonColumn", fieldName: "buttonColumn", button: 'image', header : { text: this.text.deploy }, width: 55, cursor: 'pointer',
				buttonVisibility: (grid, index, focused) => {
					let docNo = grid.getValue(index.itemIndex, 'DOC_NO');
					
					return !_.isEmpty(docNo);
				}, 
				renderer: {
					type: 'imageButtons',
					alignment: 'center',
					images: [{
						name: 'more',
						up: './assets/images/grid/deploy.png',
						width: 20
					}]
				}
			}
		]);
		
		this.gridView.onImageButtonClicked = (grid, itemIndex, column, buttonIndx, name) => {
			this.closeModal(true);
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true);
		};
	}
	
	getCrsNo() {
		let userId = this.data.userId;
		
		this.httpService.get(`/intrfccoms/csrList/${userId}`).then(data => {
			
			if(data.isError){
				this.popupService.detailAlert(this.$scope, data.data.message, data.data.stackTrace, data.data.parameters);
				return;
			}
			
			if(data.length == 0){
				this.popupService.simpleAlert(this.$scope, this.text.noCsrData);
				return;
			}
			
			this.dataProvider.setRows(data);
		});
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getCrsNo(true);
	}
	
	search(){
		this.getCrsNo(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getCrsNo(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getCurrent();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection.itemIndex));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
}

module(App.name).controller('SCR0709Controller', SCR0709Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0709/SCR0709.controller.js